module.exports = __webpack_public_path__ + "static/actionlist-sentence-do-3874824e6df1881c9a072e99c3099c46.png";